/* eslint-disable prefer-destructuring */
/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true }] */

class ListNode {
  constructor(value) {
    this.value = value;
    this.next = undefined;
    this.previous = undefined;
    this.index = NaN;
  }

  setNextNode(node) {
    if (!(node instanceof ListNode)) throw new Error('Should set node as ListNode type!');
    this.next = node;
  }

  setPreviousNode(node) {
    if (!(node instanceof ListNode)) throw new Error('Should set node as ListNode type!');
    this.previous = node;
  }
}

export default class LinkedList {
  constructor(array = [], options = { cyclic: true }) {
    if (!Array.isArray(array)) throw new Error('Initialize LinkedList with an Array!');
    this.size = array.length;
    this._cyclicList = (typeof options.cyclic === 'boolean') ? options.cyclic : true;
    this._indexMap = new Map();

    if (this.size > 1) {
      this._head = new ListNode(array[0]);
      this._tail = new ListNode(array[this.size - 1]);

      let previousNode = this._head;
      this._indexMap.set(0, this._head);
      this._head.index = 0;

      for (let i = 1; i < this.size - 1; i += 1) {
        const value = array[i];
        previousNode.setNextNode(new ListNode(value));
        previousNode.next.setPreviousNode(previousNode);

        previousNode = previousNode.next;
        this._indexMap.set(i, previousNode);
        previousNode.index = i;
      }

      previousNode.setNextNode(this._tail);
      this._tail.setPreviousNode(previousNode);
      this._indexMap.set(this.size - 1, this._tail);
      this._tail.index = this.size - 1;
    } else if (this.size === 1) {
      this._head = new ListNode(array[0]);
      this._tail = undefined;
      this._indexMap.set(0, this._head);
      this._head.index = 0;
    } else {
      this._head = undefined;
      this._tail = undefined;
    }

    /* Cyclic list */
    if (this._cyclicList && this.size > 1) {
      this._head.setPreviousNode(this._tail);
      this._tail.setNextNode(this._head);
    }
  }

  static isLinkedList(list) {
    return list.constructor.name === 'LinkedList';
  }

  static isListNode(listNode) {
    return listNode.constructor.name === 'ListNode';
  }

  * [Symbol.iterator]() {
    const nodes = this.nodes();
    for (let i = 0; i < this.size; i += 1) {
      yield nodes[i].value;
    }
  }

  nodes() {
    return Array.from(this._indexMap.values());
  }

  push(value) {
    const newArrayValues = Array.from(this);
    newArrayValues.push(value);
    return new LinkedList(newArrayValues);
  }

  concat(arrayOrList = []) {
    if (!(Array.isArray(arrayOrList) || LinkedList.isLinkedList(arrayOrList))) {
      throw new Error('LinkedList should concat with another array or LinkedList');
    }

    const newArrayValues = Array.from(this);
    return new LinkedList(newArrayValues.concat(Array.from(arrayOrList)));
  }

  pop() {
    const newArrayValues = Array.from(this);
    newArrayValues.pop();
    return new LinkedList(newArrayValues);
  }

  getNode(index) {
    return this._indexMap.get(index);
  }

  get(index) {
    const node = this.getNode(index);
    return (node !== undefined && node.value !== undefined) ? node.value : undefined;
  }

  indexOf(value) {
    return Array.from(this).indexOf(value);
  }
}



// WEBPACK FOOTER //
// ./src/helpers/LinkedList.js